import update from 'react-addons-update';

export function computePosts(postKeyList, postMap) {
  let posts = [];
  for(let i=0; i<postKeyList.length; i++) {
    let hash = postKeyList[i];

    let entry = {
      hash : postKeyList[i],
      text : postMap[hash],
      id : postKeyList.length - i - 1
    };

    posts.push(entry);
  }

  return posts;
}

export default function reducer(state={
    posts: [],
    postKeyList: [],
    postMap: {},
    text: ""
  }, action) {

    switch (action.type) {
      case "REPLACE_KEY_LIST": {

        let newPostKeyList = action.payload;
        let newPosts = computePosts(newPostKeyList, state.postMap);
        return {...state, postKeyList: newPostKeyList, posts:newPosts}
      }
      case "ADD_POST_MAP_ENTRY": {

        let key = action.payload.key;
        let text = action.payload.text;

        let newPostMap = update(state.postMap, {$merge: {[key]: text}});
        let newPosts = computePosts(state.postKeyList, newPostMap);
        return {...state, postMap: newPostMap, posts:newPosts}
      }
      case "NEW_POST_FULFILLED": {

        let key = action.payload.key;
        let text = action.payload.text;

        let newPostKeyList = update([key], {$push: state.postKeyList});
        let newPostMap = update(state.postMap, {$merge: {[key]: text}});
        let newPosts = computePosts(newPostKeyList, newPostMap);

        return {...state, postKeyList: newPostKeyList, postMap: newPostMap, posts: newPosts, text: ""}
      }
      case "UPDATE_POST_INPUT": {
        return {...state, text: action.payload}
      }
      default: {
        return state
      }
    }
}



// WEBPACK FOOTER //
// ./src/reducers/wallReducer.js